export default "/_next/static/chunks/fonts/Ionicons-3517aeaa34b2f8cd8eeff67af0daab33.ttf";